import {
  cibAdobeAcrobatReader,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay, 
  cibCcAmex
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilAddressBook,
  cilAlbum,
  cilArrowRight,
  cilArrowCircleTop,
  cilArrowCircleRight,
  cilArrowCircleBottom,
  cilArrowCircleLeft,
  cilArrowThickFromTop,
  cilAccountLogout,
  cilAvTimer,
  cilBadge,
  cilBalanceScale,
  cilBan,
  cilBank,
  cilBarChart,
  cilBarcode,
  cilBasket,
  cilBell,
  cilBriefcase,
  cilBuilding,
  cilBullhorn,
  cilCalculator,
  cilCalendar,
  cilCalendarCheck,
  cilCaretLeft,
  cilCaretRight,
  cilCart,
  cilCash,
  cilCast,
  cilCenterFocus,
  cilClock,
  cilClone,
  cilCloudDownload,
  cilClipboard,
  cilChart,
  cilChartLine,
  cilChartPie,
  cilChatBubble,
  cilCheck,
  cilCheckAlt,
  cilChevronBottom,
  cilChevronCircleDownAlt,
  cilChevronCircleLeftAlt,
  cilChevronCircleRightAlt,
  cilChevronCircleUpAlt,
  cilChevronDoubleLeft,
  cilChevronDoubleRight,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCheckCircle,
  cilCog,
  cilColumns,
  cilCommentSquare,
  cilContact,
  cilCursor,
  cilDescription,
  cilDevices,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEnvelopeLetter,
  cilEuro,
  cilExitToApp,
  cilFile,
  cilFindInPage,
  cilFolder,
  cilFolderOpen,
  cilFunctions,
  cilGlobeAlt,
  cilGrid,
  cilHome,
  cilHistory,
  cilInfo,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLibrary,
  cilLibraryAdd,
  cilLifeRing,
  cilLightbulb,
  cilList,
  cilListRich,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaRecord,
  cilMinus,
  cilMoney,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPenNib,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPlaylistAdd,
  cilPlus,
  cilPuzzle,
  cilPrint,
  cilQrCode,
  cilReload,
  cilRunning,
  cilSearch,
  cilSettings,
  cilSitemap,
  cilShieldAlt,
  cilShortText,
  cilSortNumericDown,
  cilSortNumericUp,
  cilMoodVeryBad,
  cilSad,
  cilSmile,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSync,
  cilTag,
  cilTask,
  cilThumbDown,
  cilThumbUp,
  cilTrash,
  cilTruck,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserPlus,
  cilUserUnfollow,
  cilUserX,
  cilViewQuilt,
  cilWarning,
  cilWindowRestore,
  cilX,
  cilXCircle
} from '@coreui/icons'

export const iconsSet = Object.assign(
  {},
  {
    cilAddressBook,
    cilAlbum,
    cilArrowRight,
    cilArrowCircleTop,
    cilArrowCircleRight,
    cilArrowCircleBottom,
    cilArrowCircleLeft,
    cilArrowThickFromTop,
    cilAccountLogout,
    cilAvTimer,
    cilBalanceScale,
    cilBadge,
    cilBan,
    cilBank,
    cilBasket,
    cilBarChart,
    cilBarcode,
    cilBell,
    cilBriefcase,
    cilBuilding,
    cilBullhorn,
    cilCalculator,
    cilCalendar,
    cilCalendarCheck,
    cilCaretLeft,
    cilCaretRight,
    cilCart,
    cilCash,
    cilCenterFocus,
    cilClock,
    cilClone,
    cilCloudDownload,
    cilClipboard,
    cilChart,
    cilCast,
    cilChartLine,
    cilChartPie,
    cilChatBubble,
    cilCheck,
    cilCheckAlt,
    cilChevronBottom,
    cilChevronCircleDownAlt,
    cilChevronCircleLeftAlt,
    cilChevronCircleRightAlt,
    cilChevronCircleUpAlt,
    cilChevronDoubleLeft,
    cilChevronDoubleRight,
    cilChevronLeft,
    cilChevronRight,
    cilChevronTop,
    cilCheckCircle,
    cilCog,
    cilColumns,
    cilContact,
    cilCommentSquare,
    cilCursor,
    cilDescription,
    cilDevices,
    cilDrop,
    cilDollar,
    cilEnvelopeLetter,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilExitToApp,
    cilFile,
    cilFindInPage,
    cilFolder,
    cilFolderOpen,
    cilFunctions,
    cilGlobeAlt,
    cilGrid,
    cilHome,
    cilHistory,
    cilInfo,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLibrary,
    cilLibraryAdd,
    cilLifeRing,
    cilLightbulb,
    cilList,
    cilListRich,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMap,
    cilMediaRecord,
    cilMinus,
    cilMoney,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperclip,
    cilPaperPlane,
    cilPenNib,
    cilPencil,
    cilPhone,
    cilPlus,
    cilPeople,
    cilPlaylistAdd,
    cilPuzzle,
    cilPrint,
    cilQrCode,
    cilReload,
    cilRunning,
    cilSearch,
    cilSettings,
    cilSitemap,
    cilShieldAlt,
    cilShortText,
    cilSortNumericDown,
    cilSortNumericUp,
    cilMoodVeryBad,
    cilSad,
    cilSmile,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilSync,
    cilTag,
    cilTask,
    cilTrash,
    cilTruck,
    cilThumbDown,
    cilThumbUp,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilUserPlus,
    cilUserUnfollow,
    cilUserX,
    cilViewQuilt,
    cilWarning,
    cilWindowRestore,
    cilX,
    cilXCircle
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl
  },
  {
    cibAdobeAcrobatReader,
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard, 
    cibCcVisa, 
    cibStripe, 
    cibPaypal, 
    cibGooglePay,
    cibCcAmex
  }
)
